import React from 'react';
import { motion } from 'framer-motion';
export function GenreSection() {
  const genres = [{
    name: 'Pop',
    icon: '🎤'
  }, {
    name: 'R&B',
    icon: '🎷'
  }, {
    name: 'Ballad',
    icon: '🌙'
  }, {
    name: 'Hip-Hop',
    icon: '🧢'
  }, {
    name: 'Jazz',
    icon: '🎹'
  }, {
    name: 'Rock',
    icon: '🎸'
  }, {
    name: 'Classical',
    icon: '🎻'
  }, {
    name: 'Folk',
    icon: '🍂'
  }, {
    name: 'Electronic',
    icon: '⚡'
  }];
  return <section className="bg-black py-20 md:py-28 px-6 overflow-hidden" data-id="element-37">
      <div className="max-w-5xl mx-auto flex flex-col items-center" data-id="element-38">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="text-center mb-12" data-id="element-39">
          <h2 className="text-4xl md:text-6xl font-black text-white mb-10 leading-tight" data-id="element-40">
            Any genre you want
          </h2>

          <div className="flex flex-wrap justify-center gap-3 max-w-2xl mx-auto" data-id="element-41">
            {genres.map((genre, index) => <motion.div key={genre.name} initial={{
            opacity: 0,
            scale: 0.8
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.3,
            delay: index * 0.04
          }} className="bg-white text-black px-5 py-2.5 rounded-full font-bold text-base flex items-center gap-2 shadow-md" data-id="element-42">
                <span data-id="element-43">{genre.icon}</span>
                {genre.name}
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}